/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bluesky-mono': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" d="M12.447 9.949c3.057 2.347 6.346 7.103 7.553 9.655 1.208-2.552 4.496-7.31 7.553-9.655 2.206-1.693 5.78-3.003 5.78 1.165 0 .832-.466 6.992-.74 7.992-.952 3.478-4.42 4.364-7.506 3.827 5.393.939 6.765 4.047 3.802 7.155-5.626 5.901-8.088-1.482-8.72-3.374-.114-.346-.168-.509-.169-.37 0-.139-.055.024-.17.37-.631 1.892-3.091 9.275-8.72 3.374-2.962-3.108-1.59-6.216 3.803-7.155-3.085.537-6.554-.35-7.506-3.827-.274-1-.74-7.16-.74-7.992 0-4.168 3.573-2.858 5.78-1.165Z" _fill="#686A7A"/>'
  }
})
